module.exports = "pegasus/assets/tech/email1-gallery-img4.png";